<!--
 * @Description: 机构注册审核结果组件
 * @Author: wanqian
 * @Date: 2022-05-30 15:01:35
-->
<template>
	<!-- 审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回	 -->
  <div :class="review.status == 1 ? 'inst-reg-review-result-body inst-reg-review-result-body-blue' 
		: review.status == 2 ? 'inst-reg-review-result-body inst-reg-review-result-body-red' 
		: 'inst-reg-review-result-body'">
    <el-row type="flex" >
			<div class="text">审核结果：</div>
			<div :class="review.status == 1 ? 'text text-blue' : review.status == 2 ? 'text text-red' : 'text'">
				{{review.statusText}}
			</div>
			<div class="text" style="margin-left: 50px">
				{{review.status == 0 || review.status == 3 ? (review.submiterText ? ('提交人：' + review.submiterText) : '') 
					: (review.reviewerText ? ('审核人：' + review.reviewerText) : '')}}
			</div>
			<div class="text" style="margin-left: 50px">
				{{review.status == 0 || review.status == 3 ? (review.submitTime ? ('提交时间：' + review.submitTime) : '') 
					: (review.reviewTime ? ('审核时间：' + review.reviewTime) : '')}}
			</div>
    </el-row>
		 <el-row type="flex" style="margin-top: 15px" align="top" v-if="review.status != 0 && review.comment">
			<i class="el-icon-info" :class="review.status == 1 ? 'text text-blue' : review.status == 2 ? 'text text-red' : 'text'"
				style="font-size: 16px; margin-top: 0px">
			</i>
			<div style="margin-left: 10px">
				<div :class="review.status == 1 ? 'text text-blue' : review.status == 2 ? 'text text-red' : 'text'">
					审核意见：
				</div>
				<div :class="review.status == 1 ? 'text text-blue' : review.status == 2 ? 'text text-red' : 'text'">
					{{review.comment}}
				</div>
			</div>
		 </el-row>
  </div>
</template>

<script>
export default {
	props: ["review", ],
}
</script>

<style scope>
.inst-reg-review-result-body {
		padding: 23px 31px;
}
.inst-reg-review-result-body-blue {
    background-color: #F5F8FE;
}
.inst-reg-review-result-body-red {
    background-color: #FEF6F6;
}
.text {
	font-size: 15px;
	color: #525254;
	line-height: 21px;
}
.text-blue {
	color: #3E7EF6;
}
.text-red {
	color: #E14A52;
}
</style>


// WEBPACK FOOTER //
// src/components/common/components/ReviewResult.vue